import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';

import { InlineSVGModule } from 'ng-inline-svg-2';
import { IModalButton } from '../../../../core/interfaces/interface';
import { ScrollService } from '../../../../core/services/scroll.service';
import { SharedModule } from '../../../shared-module';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input() btnCancelName?: string;
  @Input() btnSubmits?: IModalButton<any>[];
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'auth' = 'md';
  @Output() onClose = new EventEmitter();

  @Output() onSubmit = new EventEmitter<any>();
  constructor(private scrollService: ScrollService) {}
  // @HostListener('click', ['$event'])
  // onClickOutSite(event:MouseEvent) {
  //   if((event.target as HTMLElement).classList.contains('modal__overlay'))
  //   {
  //   this.onClose.emit();
  //   }
  // }

  ngOnInit() {
    this.scrollService.disableScroll();
  }

  ngOnDestroy() {
    this.scrollService.enableScroll();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeyup(event: any) {
    this.onClose.emit();
  }
}
